import { makeAutoObservable } from 'mobx';
import { IServerOrganization, ServerOrganization } from './ServerOrganization';
import { IUser, User } from '../User';
import { IServerVolunteer, ServerVolunteer } from './ServerVolunteer';
import { UserProfileTypes } from '../../../data/UserProfileTypes';

type IServerUserProfile = { 
    id: number, 
    type: string, 
    default: boolean, 
    active: boolean, 
    identity: ServerVolunteer | ServerOrganization 
};

export interface IServerUser {
    id: number;
    email: string;
    active: boolean;
    requiresSubscription: boolean;
    registrationTimestamp: number;
    profileData?: IServerUserProfile[];
}

export class ServerUser implements IServerUser {
    id: number;
    email: string;
    active: boolean;
    requiresSubscription: boolean;
    registrationTimestamp: number;
    profileData?: IServerUserProfile[];

    constructor(clientOrServerObject: IUser | IServerUser) {
        makeAutoObservable(this);

        this.id = clientOrServerObject.id;
        this.email = clientOrServerObject.email;
        this.active = clientOrServerObject.active;
        this.requiresSubscription = clientOrServerObject.requiresSubscription;
        this.registrationTimestamp = clientOrServerObject.registrationTimestamp;
        if (clientOrServerObject.profileData) {
            this.profileData = clientOrServerObject.profileData.map(profile => {
                if (profile.type === UserProfileTypes.Volunteer) {
                    return {
                        id: profile.id,
                        type: profile.type,
                        default: profile.default,
                        active: profile.active,
                        identity: new ServerVolunteer(profile.identity as IServerVolunteer)
                    }
                } else {
                    return {
                        id: profile.id,
                        type: profile.type,
                        default: profile.default,
                        active: profile.active,
                        identity: new ServerOrganization(profile.identity as IServerOrganization)
                    }
                }
            });
        }
    }

    deserialize(): User {
        const userData: IUser = {
            id: this.id,
            email: this.email,
            active: this.active,
            requiresSubscription: this.requiresSubscription,
            registrationTimestamp: this.registrationTimestamp,
            profileData: this.profileData?.map(profile => {
                return {
                    id: profile.id,
                    type: profile.type,
                    default: profile.default,
                    active: profile.active,
                    identity: profile.identity.deserialize()
                }
            })
        }
        return new User(userData);
    }
}